export default __webpack_public_path__ + "dce8f51aa08b608858e18ab8ba323f55.gif";